import { createContext, useContext } from 'react'

/** What showing a toast is, handed down by the provider in `toaster.tsx`. */
export const ToastContext = createContext<((message: string) => void) | null>(null)

export function useToast(): (message: string) => void {
  const show = useContext(ToastContext)
  if (show === null) {
    throw new Error('useToast needs a <ToastProvider> above it')
  }
  return show
}
